// extracted by mini-css-extract-plugin
export default {"rating":"SA-z","numberOfStars":"TA-z","count":"UA-z","barGraphSpacing":"VA-z","barGraph":"WA-z"};